import { useState, useEffect } from "react";
import {
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Skeleton
} from "@mui/material";
 

import { Link, useLocation, useNavigate } from "react-router-dom";
import DateFormatter from "../../../utils/dateFormatterUtils";
import useDelete from "../../../hooks/useDelete";
import Swal from "sweetalert2";
import Spinner from "../../../components/Spinner";
import FilterComponent from "../../../components/FilterComponent";
import { format, isValid } from 'date-fns';


const LawyerTable = ({
  fetchDataFn,
  columns,
  columns_date = [],
  columns_uppercase = [],
  actions,
  other_actions = [],
  onViewDetails,
  deleteEndpoint,
  tableTitle = "List",
  primarykey = "id",
  cellStylingFn = [],
  btn_export = true,
  btn_add = true,
  txtsearch = true,
  onFilterChange,
  filters = [],
  filtersState,
  setFiltersState,

  hasTableHeader = true,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const queryParams = new URLSearchParams(window.location.search);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(
    parseInt(queryParams.get("page")) ? parseInt(queryParams.get("page")) : 1
  );
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [searchTerm, setSearchTerm] = useState(
    queryParams.get("searchTerm") ?? ""
  );
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [initialLoad, setInitialLoad] = useState(false);
  const [isLoading, setIsLoading] = useState(true);


   useEffect(() => {
        if(searchTerm.length > 0){

            if(page){
                setPage(page);
                navigate(`?searchTerm=${searchTerm}&page=${page}`);
                
            }
            else{
                setPage(1);
                navigate(`?searchTerm=${searchTerm}&page=1`);
                
            }
            
        }
        else{
            setPage(page)
            navigate(`?&page=${page}`);
        }
    }, []);


   
 

  
     useEffect(() => {
        setInitialLoad(false);
    }, [searchTerm]);

    useEffect(() => {
        if(initialLoad){
            return;
        }
        const timeoutId = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 750);

        return () => clearTimeout(timeoutId);
    }, [searchTerm,initialLoad]);

    useEffect(() => {
        fetchData();
    }, [page, rowsPerPage, sortBy, sortOrder, debouncedSearchTerm,filtersState,setFiltersState]);
 

  const fetchData = async () => {
    setInitialLoad(true);
    try {
      setIsLoading(true);
      const response = await fetchDataFn({
        page,
        rowsPerPage,
        sortBy,
        sortOrder,
        searchTerm,
        ...filtersState,
      });
      setData(response.results);
      console.log("response.results",response.results);
      setTotalItems(response.count);
      setIsLoading(false);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const { deleteData, isLoading: deleteisLoading, error } = useDelete();

  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Delete data?",
      text: "Do you want to proceed?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "btn-danger",
      cancelButtonColor: "btn-secondary",
      confirmButtonText: "Yes, proceed!",
      cancelButtonText: "No, cancel",
    });

    if (result.isConfirmed) {
      try {
        const response = await deleteData(`${deleteEndpoint}/${id}`);
        console.log("Delete successful:", response);
        fetchData();
      } catch (error) {
        console.error("Delete error:", error);
      }
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage <=0 ? 1 : newPage);
    const filterParams = filters.reduce((acc, filter) => {
      if (filter.value) {
        acc[filter.field] = filter.value;
      }
      return acc;
    }, {});
    filterParams.page = newPage;
    const searchParams = new URLSearchParams(filterParams);
    navigate(`?${searchParams.toString()}`);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const handleSort = (columnId) => {
    if (sortBy === columnId) {
      setSortOrder(sortOrder === "asc" ? "desc" : "asc");
    } else {
      setSortBy(columnId);
      setSortOrder("asc");
    }
  };

  const handleSearch = (event) => {
    setIsLoading(true);
    let search_value = event.target.value;
    setPage(1);
    navigate(`?searchTerm=${search_value}&page=1`);
    setSearchTerm(search_value);
    setIsLoading(false);
  };

  // const handleFilterChange = (field, value) => {
  //   setFilterValues((prevValues) => ({ ...prevValues, [field]: value }));
  // };

  const handleApplyFilters = () => {
    const filterParams = filters.reduce((acc, filter) => {
      if (filter.value) {
        acc[filter.field] = filter.value;
      }
      return acc;
    }, {});
    filterParams.page = 1; // Reset to the first page when applying filters
    const searchParams = new URLSearchParams(filterParams);
    navigate(`?${searchParams.toString()}`);
    fetchData();
  };

  const handleViewDetails = (item) => {
    onViewDetails(item);
  };

  const startItem = totalItems > 0 ? page * rowsPerPage + 1 - rowsPerPage : 0;
  const endItem = Math.min(page * rowsPerPage, totalItems);

  const totalPages = Math.ceil(totalItems / rowsPerPage);
  let startPage = Math.max(0, page - 1);
  let endPage = Math.min(startPage + 1, totalPages - 1);

  if (endPage - startPage < 2) {
    startPage = Math.max(0, endPage - 2);
  }

  const handleGoToPage = (event) => {
    const goToPage = parseInt(event.target.value, 10);
    if (goToPage > 0 && goToPage <= totalPages) {
      handleChangePage(null, goToPage);
    }
  };

  return (
    <>
      <div className="col-12">
        <div className="card">
          <div className="card-datatable table-responsive" style={{ width: "100%" }} >
            {hasTableHeader &&
              <div className="card-header flex-column flex-md-row">
                <div className="head-label d-flex ">
                  <h5 className="card-title mb-0">{tableTitle}</h5>
                </div>
                <div className="dt-action-buttons text-end pt-3 pt-md-0">
                  <div className="dt-buttons btn-group flex-wrap">
                    {btn_export && (
                      <div className="btn-group">
                        <button className="btn buttons-collection dropdown-toggle btn-label-info me-2" tabIndex={0} aria-controls="DataTables_Table_0" type="button" aria-haspopup="dialog" aria-expanded="false" >
                          <span>
                            <i className="bx bx-export me-sm-1" />
                            <span className="d-none d-sm-inline-block">
                              Export
                            </span>
                          </span>
                        </button>
                      </div>
                    )}
                    {btn_add && (
                      <Link to={"add/"} className="btn create-new btn-info" >
                        <span>
                          <i className="bx bx-plus me-sm-1" />
                          <span className="d-none d-sm-inline-block">
                            Add New Record
                          </span>
                        </span>
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            }



                      <div className="d-flex justify-content-between align-items-center m-4">

                          {txtsearch && (
                              <div className="d-flex justify-content-start mt-4">
                                  <input
                                      type="text"
                                      className="form-control me-4"
                                      placeholder="Search ..."
                                      value={searchTerm}
                                      onChange={handleSearch}
                                  />
                              </div>
                          )}

                          {filters.length > 0 && (
                              <FilterComponent
                                  filters={filters}
                                  filtersState={filtersState}
                                  handleFilterChange={onFilterChange}
                                  hasExportPDF={false}
                              />
                          )}
                      </div>


          

            
            

            <Table className="dt-fixedheader table table-striped table-hover b-0">
              <thead>
                <tr>
                  {columns.map((column) => (
                    <th key={column.id} onClick={() => totalItems > 0 && handleSort(column.field)} >
                      {column.headerName}
                      {sortBy === column.field
                        ? sortOrder === "asc"
                          ? " ▲"
                          : " ▼"
                        : ""}
                    </th>
                  ))}
                  <th className="d-none">Actions</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <tr>
                    {/* <td colSpan={columns.length + 1} className="p-0">
                        <Skeleton animation="wave" variant="text" width="100%" height={100} sx={{  bgcolor: 'grey.200',padding:0 }} />
                    </td> */}

                    {[...Array(columns.length + 1)].map((column, index) => (
                      <td key={index} className="p-2">
                        <Skeleton
                          animation="wave"
                          variant="text"
                          width="100%"
                          height={30}
                          sx={{ bgcolor: 'grey.200' }}
                        />
                      </td>
                    ))}


                  </tr>
                ) : (
                  totalItems > 0 ?
                  data.map((row, index) => (
                    <tr key={row[primarykey]}>


                      {columns.map((column) => {
                        let cellValue = row[column.field];

                        // Format date if it's a date column
                        if (columns_date.includes(column.field)) {
                          cellValue = cellValue ? DateFormatter(cellValue, "MM DD, YYYY"): '';
                        } else if (columns_uppercase.includes(column.field)) {
                          // Convert to uppercase if it's in the uppercase list
                          cellValue = cellValue?.toUpperCase?.() ?? '';
                        } else if (cellStylingFn.length > 0) {
                          // Apply custom cell styling function
                          cellValue = cellStylingFn(column.field, cellValue);
                        }

                        return <td key={`${row.id}-${column.field}`}>{cellValue}</td>;
                      })}


                      {/* {columns.map((column) => (
                        <td key={`${row.id}-${column.field}`}>
                          {columns_date.includes(column.field)
                            ? DateFormatter(row[column.field], "MM DD, YYYY")
                            : cellStylingFn.length > 0
                            ? cellStylingFn(column.field, row[column.field])
                            : row[column.field]}
                        </td>
                      ))} */}





                      <td className="d-none">
                        <button type="button" className="btn btn-info dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="true" >
                          Action
                        </button>
                        <ul className="dropdown-menu" data-popper-placement="bottom-start" style={{ position: "absolute", inset: "0px auto auto 0px", margin: 0, transform: "translate(0px, 40px)", }} >
                          <li>
                            <button className="dropdown-item" onClick={() => handleViewDetails(row)} >
                              <i className="fas fa-info-circle"></i> ViewDetails
                            </button>
                          </li>
                          <Link to={{ pathname: "./update/" + row[primarykey], search: searchTerm && `?searchTerm=${searchTerm}&page=${page}`, }} className="dropdown-item">
                            <i className="bx bx-edit-alt me-1"></i>Edit
                          </Link>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          {other_actions.length > 0 ? other_actions(row) : []}
                          <li>
                            <button className="dropdown-item" onClick={() => handleDelete(row[primarykey])} >
                              <i className="bx bx-trash me-1"></i> Delete
                            </button>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  ))

                  :
                  
                  
                   <tr>
                      <td colSpan={columns.length + 1} className="text-center fw-bold">
                        NO DATA AVAILABLE
                      </td>
                    </tr>


                 

                )}
              </tbody>
            </Table>


            <div className="pagination-container d-flex d-none justify-content-between mx-4 mt-4">
              <div className="text-gray-600" role="status" aria-live="polite">
                Showing {startItem} to {endItem} of {totalItems} entries
              </div>

              <nav aria-label="Page navigation">
                <ul className="pagination justify-content-end">
                  {/* Previous button */}
                  <li className="page-item prev">
                    <button
                      className="page-link"
                      onClick={() => handleChangePage(null, page - 1)}
                      disabled={page === 1}
                    >
                      <i className="tf-icon bx bx-chevrons-left"></i>
                    </button>
                  </li>
                  {/* Page numbers */}
                  {totalItems > 0 &&
                    [...Array(endPage - startPage + 1).keys()].map(
                      (pageNumber, index) => (
                        <li key={index} className={`d-none page-item ${ startPage + pageNumber === page ? "active" : "" }`} >
                          <button
                            className="page-link"
                            onClick={() =>
                              handleChangePage(null, startPage + pageNumber)
                            }
                          >
                            {startPage + pageNumber + 1}
                          </button>
                        </li>
                      )
                    )}
                  {/* Next button */}
                  <li className="page-item next">
                    <button
                      className="page-link"
                      onClick={() => handleChangePage(null, page + 1)}
                      disabled={page === Math.ceil(totalItems / rowsPerPage)}
                    >
                      <i className="tf-icon bx bx-chevrons-right"></i>
                    </button>
                  </li>
                </ul>
              </nav>
            </div>

            {totalItems > 0 && (
              <div className="card-footer d-flex justify-content-between align-items-center">
                <div className="d-flex justify-content-start">
                  <span>
                    Showing {startItem} to {endItem} of {totalItems} entries
                  </span>
                </div>

                <div className="d-flex flex-row ">
                  <div className="d-flex pagination justify-content-center">
                    <input
                      type="number"
                      className="form-control"
                      style={{ width: 125 }}
                      placeholder="Go to page.."
                      aria-label="Go to page.."
                      aria-describedby="button-addon2"
                      min="1"
                      max={totalPages}
                      onChange={handleGoToPage}
                    />
                    <button
                      className="btn btn-info ms-1"
                      type="button"
                      id="button-addon2"
                      onClick={handleGoToPage}
                    >
                      Go
                    </button>

                    <button
                      className="btn btn-info w-100  ms-2"
                      onClick={() => handleChangePage(null, 1)}
                      disabled={page === 1}

                    >
                      First
                    </button>

                    <button
                      className="btn btn-info ms-1 w-100"
                      onClick={() => handleChangePage(null, totalPages)}
                      disabled={page === Math.ceil(totalItems / rowsPerPage)}
                    >
                      Last
                    </button>

                    <button
                      className="btn btn-info ms-1 w-100"
                      onClick={() => handleChangePage(null, page - 1)}
                      disabled={page === 1}
                    >
                      Prev
                    </button>
                    <button
                      className="btn btn-info ms-1 w-100"
                      onClick={() => handleChangePage(null, page + 1)}
                      disabled={page === Math.ceil(totalItems / rowsPerPage)}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LawyerTable;
